export default "__VITE_ASSET__DAlRcBI8__"